import { graphql } from '@gql';

export const ContentSectionFragment = graphql(/* GraphQL */ `
  fragment ContentSectionFragment on VildarPageComponentsContentSection {
    ... on VildarPageComponentsContentSection {
      __typename
      content_section {
        cta {
          label
          external_link {
            href
            title
          }
          internal_linkConnection {
            edges {
              node {
                ... on VildarPage {
                  title
                  url
                }
                ... on VildarContentPosts {
                  title
                  url
                }
              }
            }
            totalCount
          }
        }
        headline
        layout
        paragraph
        variant
        image {
          alt_text
          crop_resize
          gravity
          imgConnection {
            ...SysAssetConnectionFragment
          }
        }
        video {
          url
          autoplay
          controls
        }
        content_postConnection {
          edges {
            node {
              ... on VildarContentPosts {
                date
                show_date
                display_title
                short_description
                url
                type
                image {
                  crop_resize
                  gravity
                  alt_text
                  assetConnection {
                    ...SysAssetConnectionFragment
                  }
                }
              }
            }
          }
          totalCount
        }
      }
    }
  }
`);
